const isIOS = !window.MSStream && /iPad|iPhone|iPod|Mac/.test(navigator.userAgent);

export default isIOS;
